import { render, staticRenderFns } from "./Framework.vue?vue&type=template&id=0f2a3f3c&scoped=true"
import script from "./Framework.vue?vue&type=script&lang=js"
export * from "./Framework.vue?vue&type=script&lang=js"
import style0 from "./Framework.vue?vue&type=style&index=0&id=0f2a3f3c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a3f3c",
  null
  
)

export default component.exports